<template>
  <div>
    <el-dialog :title="dialogTitle" :visible.sync="isShowParm" :close-on-click-modal ="false"  align="left" width="30%" @close="close">
      <div style="margin-bottom:10px;">Choose the sampling mode for these PVs:</div>
      <el-select v-model="sampleModeValue"  style="width:150px;">
        <el-option
          v-for="item in sampleMode"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          >
        </el-option>
      </el-select>
      <div style="margin-bottom:10px;margin-top:10px;">Set the sampling period for the PV to :</div>
      <div style="margin-bottom:10px;margin-top:10px;"> 
        <el-input  v-model="samplePeriod" style="width:150px;"></el-input>
        <label>(secs)</label>
      </div>
      <div style="margin-top:10px;">
        <el-button align="right" v-on:click="okChangeParameters()" type="info" plain>Ok</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    export default {
        name: "archiveSpecify",
        props:{
          pvName:{
            type:String,
            default:''
          }
        },
        computed:{
          dialogTitle:{
            get:function() {
              return 'Specify the sampling period for these PVs'
            }
          }
        },
        data(){
          return {
            isShowParm:true,
            sampleModeValue:'MONITOR',
            sampleMode:[{
              value:'MONITOR',
              label:'Monitor'
            },{
              value:'SCAN',
              label:'Scan'
            }],
            samplePeriod:'1.0',
            policy:'',
            controllingPV:''
          }
        },
      mounted(){
        this.query();
      },
      methods:{
        query(){},
        close:function(){
          this.$emit('close');
        },
        //改变archival parameters
        okChangeParameters(){
          if(!(/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(this.samplePeriod)){
            alert('Please enter a number greater than 0');
          }else{
            let str = ''
            if(this.controllingPV){
              str+='&controllingPV=' + this.controllingPV;
            }else{
              str+='';
            }
            if(this.policy){
              str+='&policy=' + this.policy;
            }else{
              str+='';
            }
            this.$axios({ 
              method:'get',
              url:'/hdars/hdars/mgmt/archivePV?pv='+ this.pvName + '&samplingperiod=' + this.samplePeriod + '&samplingmethod=' + this.sampleModeValue + str
            }).then(() => {
                this.$message('Operation successful');
                this.close();
                this.$emit('refreshtable');
            }).catch( ()=>{this.$message('Operation failed');})
          }
        },
      }
    }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/activePublic/pvManagement/archiveSpecify.vue